var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"600"}},[_c('v-card-title',[_vm._v("Authentication failed")]),_c('v-card-subtitle',[_vm._v(" We were unable to authenticate your account with Shopify. Please try again. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }